import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'app-data-source-indicator',
  standalone: true,
  template: `
    @if (isFirebaseMode()) {
      <div class="flex items-center gap-2 text-xs px-2.5 py-1 rounded-full bg-green-200 text-green-800 font-semibold" [title]="'dataSource.liveTooltip' | translate">
        <i class="fa-solid fa-bolt"></i>
        <span>{{ 'dataSource.live' | translate }}</span>
      </div>
    } @else {
      <div class="flex items-center gap-2 text-xs px-2.5 py-1 rounded-full bg-yellow-200 text-yellow-800 font-semibold" [title]="'dataSource.mockTooltip' | translate">
        <i class="fa-solid fa-database"></i>
        <span>{{ 'dataSource.mock' | translate }}</span>
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe]
})
export class DataSourceIndicatorComponent {
  isFirebaseMode = input.required<boolean>();
}